/**
 * debug settings for when debug is enabled in the envService
 * the 'use' properties toggle options
 * below them are more specific information related to the toogle
 * or new options
 */
angular.module('tgaApp').constant('debugData', {
  use: {
    // use music provided locally
    music: false,
    // use a JSON gameData file
    gameData: false,
    // set the starting state of the game
    initialState: true,
  },
  // disable API calls from the APIManager
  noAPI: false,
  // set the initial state
  initialState: 'splash',
  // path to debug music file
  music: 'assets/debug/music.mp3',
  // path to gameData JSON file
  gameData: 'assets/debug/game-data.json',
});
